import { createContext } from "react";
import type { ElkDirection } from "./hooks/useElkLayout";

export const DiagramDirectionContext = createContext<ElkDirection>("DOWN");
